
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { useState } from "react";
import { Loader2 } from "lucide-react";

export const handleGoogleLogin = async () => {
  try {
    console.log('Starting Google login process...');
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
        redirectTo: window.location.origin,
        scopes: 'profile email',
      },
    });

    if (error) {
      console.error('Google login error:', error);
      throw error;
    }

    console.log('Google login initiated successfully:', data);
    return data;
  } catch (error) {
    console.error('Error in handleGoogleLogin:', error);
    throw error;
  }
};

export function Auth() {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    console.log('Auth button clicked');
    setIsLoading(true);
    try {
      await handleGoogleLogin();
      console.log('Google login flow started successfully');
    } catch (error) {
      console.error('Login error:', error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to login with Google. Please try again.",
        variant: "destructive",
      });
    } finally {
      console.log('Finishing auth flow...');
    }
  };

  return (
    <div 
      onClick={handleClick}
      className="text-[20px] cursor-pointer hover:opacity-80 transition-opacity"
    >
      {isLoading ? (
        <div className="flex items-center gap-2">
          <Loader2 className="h-4 w-4 animate-spin" />
          Connecting...
        </div>
      ) : (
        "Try for Free"
      )}
    </div>
  );
}

